<template>
  <div class="container">
    <div>
      <h4 class="title">{{$t('deliveryGoods.expressReturnTicket')}}</h4>
      <div class="separator"></div>
    </div>
    <el-form :model="form" ref="refForm" :rules="rules" label-width="180px">
      <el-form-item label-width="0" style="margin-bottom: 0;">
        <h4 style="color: #169BD5;">{{$t('deliveryGoods.deliveryInformation')}}</h4>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.productOrderNo') + ':'" prop="productOrderNo">
            <el-input
              v-model.trim="form.productOrderNo"
              disabled
              name="productOrderNo"
              disable
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.orderTime') + ':'" prop="orderDate">
            <el-input
              v-model.trim="form.orderDate"
              disabled
              name="orderDate"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64">
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.status') + ':'" prop="status">
            <el-select
              v-model="form.status"
              disabled
              clearable
              filterable
              style="width: 150px;"
              size="small">
              <el-option
                v-for="(item, key) in prodOrderStatus"
                :key="key"
                :label="item.explain"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.expectedDeliveryNumber') + ':'" prop="expectCount">
            <el-input
              v-model.trim.number="form.expectCount"
              disabled
              type="tel"
              autocomplete="on"
              clearable
              size="small"
              maxlength="10"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0" style="margin-bottom: 0;">
        <h4 style="color: #169BD5;">{{$t('deliveryGoods.customerInformation')}}</h4>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
            <el-select
              v-model="form.customerId"
              disabled
              clearable
              filterable
              style="width: 100%;"
              size="small"
              @change="changeCustomer">
              <el-option
                v-for="item in customersList"
                :key="item.id"
                :label="item.customerName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.contact') + ':'" prop="contact">
            <el-input
              v-model.trim="form.contact"
              disabled
              name="contact"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="16">
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
            <el-input
              v-model.trim="form.contactPhone"
              disabled
              name="contactPhone"
              type="tel"
              autocomplete="on"
              clearable
              size="small">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
            <el-input
              v-model.trim="form.contactAddr"
              disabled
              name="incoOrderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="20">
          <el-form-item :label="$t('common.comment') + ':'">
            <el-input
              v-model="form.comment"
              disabled
              name="comment"
              type="textarea"
              autocomplete="on"
              clearable
              size="small"
              maxlength="200"
              show-word-limit
              rows="4">
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0" style="margin-bottom: 0;">
        <h4 style="color: #169BD5;">{{$t('deliveryGoods.expressInformation')}}</h4>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.expressageNo') + ':'" prop="expressageNo">
            <el-input
              v-model.trim="form.expressageNo"
              name="expressageNo"
              disabled
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.expressageType')+ ':'" prop="expressageType">
            <el-select
              v-model="form.expressageType"
              disabled
              clearable
              filterable
              style="width: 100%;"
              size="small">
              <el-option
                v-for="(item, key) in expressageTypes"
                :key="key"
                :label="item.explain"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.expressage') + ':'" prop="expressage">
            <el-select
              v-model="form.expressage"
              disabled
              clearable
              filterable
              style="width: 100%;"
              size="small">
              <el-option
                v-for="(item, key)  in expressages"
                :key="key"
                :label="item.explain"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.returnTicket') + ':'" prop="attachment">
            <el-upload
              class="upload-demo"
              :headers="headers"
              :action="action"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              :on-error="handleError"
              :on-preview="handlerPreview"
              drag
              multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0" style="margin-bottom: 0;">
        <h4 style="color: #169BD5;">{{$t('common.binLevel')}}</h4>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.binLevel')" prop="binLevelArr">
            <el-select
              disabled
              v-model="form.binLevelArr"
              clearable
              multiple
              filterable
              style="width: 100%;"
              size="small">
              <el-option
                v-for="(item, index) in 8"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <h4 style="color: #169BD5;">{{$t('deliveryGoods.associatedBoxes')}}</h4>
      </el-form-item>
    </el-form>
    <div class="target-container">
      <el-table
        ref="table"
        border
        :data="prodStores"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName"
        :span-method="objectSpanMethod">
        <el-table-column prop="incoOrderNo" :label="$t('common.orderNo')">
        </el-table-column>
        <el-table-column prop="subNo" :label="$t('common.subNo')">
        </el-table-column>
        <el-table-column prop="boxNo" :label="$t('common.boxNo')"/>
        <el-table-column prop="binLevel" :label="$t('common.binLevel')"/>
        <el-table-column :label="$t('common.productName')" width="200">
          <template slot-scope="scope">
            {{productNameVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
        <el-table-column :label="$t('common.processType')">
          <template slot-scope="scope">
            {{processTypeVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="allCount" :label="$t('common.count')"/>
        <el-table-column :label="$t('common.passCount')">
          <template slot-scope="scope">
            {{scope.row.binLevel !== 8 ? scope.row.count : 0}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.failCount')">
          <template slot-scope="scope">
            {{scope.row.binLevel === 8 ? scope.row.count : 0}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-container">
      <el-button
        size="small"
        @click="prevStep">
        {{$t('common.back')}}
      </el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="submitForm">
        {{$t('common.submit')}}
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { customersList } from '@/api/customers';
import { consignorsList } from '@/api/consignors';
import { productOrderNoConfirm, prodOrderDetailById } from '@/api/prodOrder';
import {
  validateContactPhone,
} from '@/utils/validate';
import {
  prodOrderStatus,
  priorityLevels,
  processTypes,
  storeStatus,
  expressages,
  expressageTypes,
} from '@/utils/defines';
import { isValueEmpty, isPositiveIntegerNum } from '@/utils';

export default {
  name: 'scan-return-ticker',
  props: [
    'productOrder',
  ],
  data() {
    const prodOrderStatusObj = {};
    let prodOrderStatueItem;
    for (const key in prodOrderStatus) {
      if (Object.prototype.hasOwnProperty.call(prodOrderStatus, key)) {
        prodOrderStatueItem = prodOrderStatus[key];
        prodOrderStatusObj[prodOrderStatueItem.val] = prodOrderStatueItem.prodOderExplain || prodOrderStatueItem.explain;
      }
    }
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
      }
    }
    return {
      form: {
        productOrderNo: undefined,
        orderDate: undefined,
        customerId: undefined,
        contact: undefined,
        contactPhone: undefined,
        contactAddr: undefined,
        comment: undefined,
        expressageNo: undefined,
        expressageType: undefined,
        expressage: undefined,
        priorityLevel: undefined,
        status: undefined,
        attachment: [],
        expectCount: undefined,
        binLevelArr: undefined,
      },
      rules: {
        productOrderNo: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.productOrderNoCanNotBeEmpty') }],
        orderDate: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.orderTimeCanNotBeEmpty') }],
        status: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.statusCanNotBeEmpty') }],
        expectCount: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expectedDeliveryNumberCanNotBeEmpty') }],
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        expressageNo: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageNoCanNotBeEmpty') }],
        expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
        expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
        attachment: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.returnTicketCanNotBeEmpty') }],
        binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
      },
      loading: false,
      prodOrderStatus,
      processTypesObj,
      storeStatusObj,
      expressages,
      expressageTypes,
      prodStores: [],
      customersList: [],
    };
  },
  computed: {
    ...mapGetters([
      'token',
    ]),
    headers() {
      return {
        Authorization: `Bearer ${this.token}`,
      };
    },
    action() {
      return '/api/v1/files/prodOrder';
    },
  },
  mounted() {
    this.customersListGet(1, 200);
    this.prodOrderDetailById();
  },
  methods: {
    changeCustomer(val) {
      const {
        contact,
        contactPhone,
        contactAddr,
      } = this.form;
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
    async customersListGet(page, perpage) {
      try {
        const res = await customersList({ page, perpage });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    async prodOrderDetailById() {
      const {
        productOrderNo,
      } = this.productOrder;
      try {
        const res = await prodOrderDetailById({ productOrderNo });
        const {
          data,
        } = res;
        if (data) {
          const {
            productOrderNo,
            createAt,
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment,
            expressageNo,
            expressageType,
            expressage,
            priorityLevel,
            prodStores,
            status,
            expectCount,
            binLevelData,
          } = data.detail;
          this.form = {
            productOrderNo,
            orderDate: this.formatDate(createAt),
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment,
            expressageNo,
            expressageType,
            expressage,
            priorityLevel,
            status,
            attachment: [],
            expectCount,
            binLevelArr: binLevelData,
          };
          this.prodStores = [];
          let length, info, count, index = 0;
          for (let row of prodStores) {
            info = row.info;
            count = row.count;
            length = info.length;
            for(let i = 0; i < length; i++) {
              if (i === 0) {
                this.prodStores.push({
                  ...row,
                  ...info[i],
                  rowspan: length,
                  allCount: count,
                  index,
                });
              } else {
                this.prodStores.push({
                  ...row,
                  ...info[i],
                  allCount: count,
                });
              }
            }
          }
        }
      } catch (e) {
        // do nothing.
      }
    },
    handleSuccess(response, file, fileList) {
      this.form.attachment = fileList;
    },
    handleError() {
    },
    handleRemove(file, fileList) {
      this.form.attachment = fileList;
    },
    handlerPreview(file) {
      const url = this.attachmentUrl(file.name);
      window.open(url, 'blank');
    },
    attachmentUrl(attachment) {
      return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/prodOrder/${attachment}`;
    },
    handleBeforeUpload(file) {
      const isLessThan2M = file.size / 1024 / 1024 < 2;
      if (!isLessThan2M) {
        this.$message({
          type: 'error',
          message: this.$t('common.sizeNotExceed2M'),
        });
      }
      return isLessThan2M;
    },
    prevStep() {
      this.$emit('prevStep');
    },
    submitForm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.productOrderNoConfirm();
        }
      });
    },
    async productOrderNoConfirm() {
      const {
        productOrderNo,
      } = this.productOrder;
      const {
        attachment,
      } = this.form;
      this.loading = true;
      const fileList = [];
      for (const row of attachment) {
        fileList.push(row.name);
      }
      try {
        await productOrderNoConfirm({ productOrderNo, attachment: fileList });
        this.$message({
          type: 'success',
          message: this.$t('common.submitSuccess'),
        });
        this.$emit('nexStep');
      } catch {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    orderNoVal(row) {
      const {
        incoOrderNo
      } = row;
      return `${incoOrderNo}`;
    },
    productNameVal(row) {
      const {
        productName,
        chipName,
      } = row;
      if (!productName || !chipName) {
        return '';
      }
      return `${productName} / ${chipName}`;
    },
    processTypeVal(row) {
      const {
        processType
      } = row;
      return this.processTypesObj[processType];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    expressageVal(val) {
      return this.expressagesObj[`${val}`];
    },
    expressageTypeVal(val) {
      return this.expressageTypesObj[`${val}`];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3 || columnIndex === 7) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .upload-demo {
    margin-top: 10px;
  }
  .title {
    margin: 10px 20px;
    font-size: 16px;
    color: #555555;
  }
  .target-container {
    margin: 20px 20px 0;
  }
  .bottom-container {
    text-align: center;
    margin: 20px 0;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
</style>
